import React, { useEffect, useState } from 'react';
import { Modal, Box, ButtonGroup, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../../common/styles/styles';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { parseDayJsDate } from '../../../common/utils/massageDataUtil';
import "react-datepicker/dist/react-datepicker.css";

export default function WhatsNewModal({ item, onTriggerCreate, onTriggerUpdate }) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  
  const [formData, setFormData] = useState({
      id: '',
      created: '',
      name: '',
      description: '',
  });

  const handleOpen = () => {
    setOpen(true);
    setTitle('Create Whats New Item');    
    setFormData({ ...formData, id: '', created: null, name: '', description: '' });
  }

  const handleEditOpen = () => { 
    //Test
    if (item.created !== '') {
      const createdObj = new Date(item.created);
      const createdDt = dayjs(`${createdObj.getMonth()+1}-${createdObj.getDate()}-${createdObj.getFullYear()} ${createdObj.getHours()}:${createdObj.getMinutes()}`);
      
      setFormData({ ...formData, created: createdDt });
    }

    setOpen(true);
    setTitle('Update Whats New Item');
  }

  const handleUpdate = async (event) => {
      const result = await createItem(event);      
      
      if (result === 'success') {
        setOpen(false);
        if ( title === 'Create Whats New Item' ) {
          onTriggerCreate(formData);
        } else {
          onTriggerUpdate(formData);
        }      
      }
  }

  const handleClose = async () => {
    setOpen(false);
    if (formData.id === '') {    
      await setFormData({ ...formData, id: '', created: '', name: '', description: '' });
    }
  }
  
  const handleInputChange = (field) => (e) => {
      if (field === 'created') {
        const date = parseDayJsDate(e);
        setFormData({ ...formData, created: e, created_string: date });
      } else {
        const value = e.target.value;
        setFormData({ ...formData, [field]: value });
      }
  };
  
  const createItem = async (event) => {
    event.preventDefault();
    let result = null;

    try {
        
        if (formData.id === '') {
          const response = await fetch(`${process.env.REACT_APP_API}/whatsnew/create`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
          });

            result = await response.json();
            if (result.message === 'success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
        } else {
            const response = await fetch(`${process.env.REACT_APP_API}/whatsnew/update/${item.id}`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            result = await response.json();
            if (result.message === 'success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
          }
          return result.message;
    } catch (error) {
      toast.error('Network error.  Please try again: ', error);
      return false;
    }
  }
  
  const textFieldStyles = Styles.textFieldStyles;
  const dateFieldStyles = Styles.dateFieldStyles;

  useEffect(() => {
    if (item.id !== undefined) {
      setFormData(item);
    } 
  }, [item]);

  return (
    <>
        { formData.id === "" && 
          <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpen}>
            Add New
          </Button>
        }
        
        { formData.id !== '' && 
          <Button variant="outlined" color="success" size="small" onClick={handleEditOpen}>
              <EditIcon />
          </Button>
        }
        
        <Modal 
          open={open} 
          onClose={handleClose}
          style={{
            overlay: {
              backgroundColor: '#080030', // Semi-transparent black
            },
            content: {
              backgroundColor: '#080030',
            },
          }}
        >
            <Box sx={{color: 'white', p: 4}}>
                <Box
                  component={Paper}
                  elevation={3}
                  sx={{
                    mx: 'auto',
                    width: 400,
                    bgcolor: '#1e1e1e',
                    p: 2,
                  }}
                >
                  <Typography variant="h4" component="h2" color="white" mb={2}>
                    {title}
                  </Typography>

                  <Box component="form" onSubmit={handleUpdate}>
                    <Stack spacing={2}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          required
                          InputLabel={{
                            shrink: true, // This ensures the label is always "shrunk" above the input
                          }}
                          label="Created"
                          value={formData.created}
                          onChange={handleInputChange('created')}
                          sx={ dateFieldStyles }
                          minDate={dayjs().subtract(2, 'year')}  
                        />
                      </LocalizationProvider>
                      <TextField
                        required
                        fullWidth
                        label="Name"
                        value={formData.name}
                        onChange={handleInputChange('name')}
                        sx={ textFieldStyles }
                      />
                      <TextField
                        required
                        fullWidth
                        multiline
                        rows={4}
                        label="Description"
                        value={formData.description}
                        onChange={handleInputChange('description')}
                        sx={ textFieldStyles }
                      />
                      
                      <ButtonGroup 
                        size="small"
                        variant="contained" 
                        aria-label="Basic button group" 
                        fullWidth
                        sx={{ mt:2 }}
                      >
                        <Button
                          onClick={handleClose}
                          type="cancel"
                          variant="contained"
                          sx={ Styles.buttonStyle }
                        >
                          Cancel
                        </Button>              
                        <Button
                          type="submit"                      
                          variant="contained"
                          sx={{ ...Styles.buttonStyle,  ml:4 }}
                        >
                          {title}
                        </Button>
                      </ButtonGroup>
                </Stack>
              </Box>
            </Box>
          </Box>          
        </Modal>
    </>
  );
}